// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"4c1fe559","134":"d800ba4c"}[chunkId] + ".chunk.js";
};